import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import { GetChatAgentConversationQuery } from '@/gql/graphql';

const GET_CHAT_AGENT_CONVERSATION = graphql(`
  query GetChatAgentConversation($id: ID!) {
    chatAgentConversation(id: $id) {
      id
      createdAt
      updatedAt
      title
      summary
      messages {
        id
        role
        content
        stepNumber
        createdAt
      }
    }
  }
`);

const chatAgentConversationQueryOptions = (conversationId: string) => ({
  queryKey: meKeys.chatAgentConversation(conversationId),
  queryFn: () =>
    gqlClient.request(GET_CHAT_AGENT_CONVERSATION, { id: conversationId }),
});

const useGetChatAgentConversation = (
  conversationId: string | null,
  options?: Omit<
    UseQueryOptions<GetChatAgentConversationQuery>,
    'queryKey' | 'queryFn'
  >
) => {
  return useQuery({
    ...chatAgentConversationQueryOptions(conversationId!),
    enabled: !!conversationId,
    ...options,
  });
};

export default useGetChatAgentConversation;
